import { faChevronRight, faBatteryFull } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import EnergyTracker from './EnergyTracker';

function EnergyCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openEnergy, setOpenEnergy] = useState(false);

  const handleEnergy = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenEnergy(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openEnergy) {
      const energy = document.getElementById('snm-energy');
      setTimeout(() => {
        energy?.classList.add('slide-in');
      }, 300);
    }
  }, [openEnergy]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openEnergy) {
      const energy = document.getElementById('snm-energy');
      energy?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenEnergy(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <span className="sr-only">{t('modal.tracker.details')}</span>
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleEnergy}
              type="button"
              aria-label={t('T358')}
            >
              <div>
                <FontAwesomeIcon icon={faBatteryFull} className="mood-icon" /> {t('T358')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openEnergy && (
        <EnergyTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default EnergyCover;
